import { Button, Table, Typography } from "antd"
import React, { useState } from "react"
import moment from "moment"
import PriceRequestStatus from "../../../components/Admin/PriceRequest/PriceRequestStatus"
import RequestHistory from "../../../components/Admin/PriceRequest/RequestHistory"
import AcceptOrDeny from "../../../components/Admin/PriceRequest/AcceptOrDeny"
import ShowSavedPricesDrawer from "../../../components/Manager/Prices/ShowSavedPricesDrawer"

const { Paragraph } = Typography

export default function ActiveRequests({ activeKey, activeReq, activeReqLoading }) {
  const [expandedComments, setExpandedComments] = useState({})

  const toggleExpand = (id) => {
    setExpandedComments((prevExpandedComments) => ({
      ...prevExpandedComments,
      [id]: !prevExpandedComments[id],
    }))
  }

  const columns = [
    {
      title: "Status",
      dataIndex: "adminRequestStatus",
      width: "5%",
      render: (value, record) => {
        return (
          <>
            <PriceRequestStatus value={value} />
          </>
        )
      },
    },
    {
      title: "Client",
      dataIndex: "client",
      width: "10%",
    },
    {
      title: "Product",
      dataIndex: ["product", "productName"],
      width: "10%",
    },
    {
      title: "For manager",
      width: "10%",
      dataIndex: "userEmail",
    },
    {
      title: "Last Comment",
      render: (text, record) => {
        const isExpanded = expandedComments[record.id]
        const comment =
          record.adminRequests?.length > 0
            ? record.adminRequests[record.adminRequests.length - 1].requestComment
            : "No Comment"
        const shouldShowReadMore = comment.length > 100 // Example threshold

        return (
          <>
            <Paragraph
              ellipsis={isExpanded ? false : { rows: 2, expandable: false, symbol: "more" }}>
              {comment}
            </Paragraph>
            {shouldShowReadMore && (
              <Button size="small" type="link" onClick={() => toggleExpand(record.id)}>
                {isExpanded ? "Less" : "Read More"}
              </Button>
            )}
          </>
        )
      },
      align: "center",
      width: "20%",
    },
    {
      title: "History",
      align: "center",
      render: (record) => {
        return <RequestHistory record={record} />
      },
      width: "10%",
    },
    {
      title: "Details",
      align: "center",
      render: (value) => <ShowSavedPricesDrawer data={value} />,
      width: "10%",
    },
    {
      title: "Request Date",
      width: "10%",
      render: (text, record) => {
        // Assuming record.adminRequests contains your Firebase timestamp objects
        const lastAdminRequest =
          record.adminRequests && record.adminRequests.length > 0
            ? record.adminRequests[record.adminRequests.length - 1]
            : null

        // Convert Firebase timestamp to Moment.js date object and format it
        if (lastAdminRequest) {
          // Ensure 'requestDate' exists and has 'seconds'
          if (lastAdminRequest.requestDate && "seconds" in lastAdminRequest.requestDate) {
            // Convert seconds to milliseconds for Moment.js and format the date
            const formattedDate = moment(lastAdminRequest.requestDate.seconds * 1000).format(
              "DD.MM.YYYY"
            )
            return formattedDate
          }
        }

        return "No Date" // Fallback if no date is available
      },
      align: "center",
    },
    {
      title: "Action",
      render: (record) => {
        return <AcceptOrDeny record={record} />
      },
      width: "5%",
    },
  ]

  return (
    <div>
      <Table
        columns={columns}
        size="small"
        loading={activeReqLoading}
        rowKey={(record) => record.id}
        dataSource={activeReq}
      />
    </div>
  )
}
